<template>
  <div class="modal mymodal" :id="modalid" tabindex="-1" 
      aria-labelledby="modalid + 'Label'" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">ProSwitching DashBoard Monitor</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <h2>PROSW DASHBOARD </h2>
          <h2>VERSION {{version}}</h2>
          <img src="../assets/newprosw.png" width=120 height=30>
          <br>
          <a class="nav-link" @click="download_doc" role="button">Download Documentation </a>
          <a class="nav-link" role="button" @click="upgrade_version()"> Upgrade to the latest Release</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mymodal > div {
    position: absolute ;
    background-color: yellow;
}
.nomargin {
   margin-block-start: 0 ;
   margin-block-end : 0 ;
}
</style>

<script>
import axios from 'axios' 

export default {
  name: 'ShowVersion',
  props: {
    modalid : String
  },
  computed : {
    version() {
      return this.$store.getters.version ;
    }
  },
  methods : {
    download_doc() {
      return alert ("Document Not Available") ;
    },
    upgrade_version() {
      let req = "" ;
      let ctlid = this.$store.state.controller.pswline ;
      req = this.$store.getters.controller_url + 
            "/prosw/CFG/chkupgrade?swapid=" + ctlid  ;

      axios.get (req,  {
           timeout: 5000,
           headers: {'Pswtoken': this.$store.getters.pswtoken }
      }).then ( (response) => {
            let res = response.data ;
            if (typeof res != "object") 
              return alert ("invalid response") ;
            if (res.RESULT.version == this.version)
              alert ("You are already in the latest version " + this.version);
            else {
              let c = confirm ("Current Version is " + this.version + 
                    ".\nUpgrade to " + res.RESULT.version + "?");
              if (c) this.upgrade(res.RESULT.remotectl); 
            }
      }).catch ( (error) => { 
            if (error.code === 'ECONNABORTED') {
                alert ("action failed " + error) ;
                console.log('Request timed out');
            } else {
                alert ("action failed " + error) ;
                console.log(error.message);
          }
      })
    },
    upgrade(remotectl) {
      let ctlid = this.$store.state.controller.pswline ;
      if (! Array.isArray(remotectl)) 
        remotectl = [ ctlid ] ;
      else
        remotectl [ remotectl.length ] = ctlid ;

      for (let i = 0 ; i < remotectl.length ; i++) {
        let ctl = remotectl[i] ;
        let req = this.$store.getters.controller_url + 
            "/prosw/CFG/upgrade?swapid=" + ctl ;
        axios.get (req,  {
           timeout: 5000,
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
            let res = response.data ;
            if (typeof res != "object") 
              return alert ("invalid response") ;
            alert ("swap controller " + ctl + 
                  " updated\nRestart Swap Required !");
        }).catch ( (error) => { 
            if (error.code === 'ECONNABORTED') {
                alert ("action failed " + error) ;
                console.log('Request timed out');
            } else {
                alert ("action failed " + error) ;
                console.log(error.message);
          }
        })
     }
    }
  },
  data() {
    return {
    }
  }
}
</script>
